module.exports = __webpack_public_path__ + "static/media/play.cd3f37a0.png";